module.exports = __webpack_public_path__ + "static/media/E.f01b6926.svg";